import React from 'react';
import PropTypes from 'prop-types';
import { reduxForm, Field } from 'redux-form';
import AddSponsorLogoInput from './AddHeaderColumnImageInput';
import styles from './AddHeaderColumnImageForm.module.scss';

class AddHeaderColumnImageForm extends React.Component {
  render() {
    const { canEdit, onChangeTheatreImage } = this.props;
    return (
      <div className={styles.root}>
        <Field name="content" component={AddSponsorLogoInput} onChangeCallback={onChangeTheatreImage} canEdit={canEdit} />
      </div>
    );
  }
}

AddHeaderColumnImageForm.propTypes = {
  canEdit: PropTypes.bool.isRequired,
  onChangeTheatreImage: PropTypes.func.isRequired,
};

export default reduxForm({
  form: 'theatre-header-image',
  enableReinitialize: true,
  destroyOnUnmount: false,
  keepDirtyOnReinitialize: false,
})(AddHeaderColumnImageForm);
